export default __webpack_public_path__ + "static/media/seva.9457e590.svg";